import axios from "./httpClient";

import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { IASEntry } from "../models/shortage";
import { throwApiError } from "./apiError";

/**
 * GET API call using Axios
 */

export const GetASDetailsAPI = async (osdNumber: number | string): Promise<IASEntry> => {
  try {
    const response = await axios.get(`${getUrl(ApiType.AS_ENTRY_DETAILS)}/${osdNumber}`);
    return response?.data ?? {};
  } catch (error) {
    return throwApiError(error, ErrorMessages.aSEntryDetailsAPIError);
  }
};
